// File: frontend/src/api/index.ts
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

if (!API_BASE_URL) {
  throw new Error("FATAL ERROR: VITE_API_BASE_URL is not defined...");
}

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken'); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// THIS IS THE IMPORTANT PART TO UNCOMMENT AND USE
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token might be invalid or expired
      console.error("API request resulted in 401 Unauthorized. Token likely expired or invalid.");
      localStorage.removeItem('authToken');
      localStorage.removeItem('userRole'); // Also clear role
      localStorage.removeItem('userName'); // And user name
      
      // Redirect to login page, optionally with a message
      // Ensure you're not already on the login page to avoid a loop
      if (window.location.pathname !== '/login') {
        window.location.href = '/login?sessionExpired=true'; 
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;